import React from 'react';
import { BookOpen, MonitorPlay, Users, FileText, ClipboardCheck, Calendar, Image as ImageIcon, FileSearch, Layers } from 'lucide-react';
export function WhatsIncluded() {
  const features = [{
    icon: <BookOpen size={32} data-id="element-165" />,
    text: 'Manuales completos de 1° a 6° año'
  }, {
    icon: <MonitorPlay size={32} data-id="element-166" />,
    text: 'Clases desarrolladas'
  }, {
    icon: <ImageIcon size={32} data-id="element-167" />,
    text: 'Diapositivas listas para proyectar'
  }, {
    icon: <Users size={32} data-id="element-168" />,
    text: 'Actividades didácticas e interactivas'
  }, {
    icon: <FileText size={32} data-id="element-169" />,
    text: 'Trabajos prácticos completos'
  }, {
    icon: <ClipboardCheck size={32} data-id="element-170" />,
    text: 'Evaluaciones listas para usar'
  }, {
    icon: <Calendar size={32} data-id="element-171" />,
    text: 'Planificaciones organizadas'
  }, {
    icon: <ImageIcon size={32} data-id="element-172" />,
    text: 'Recursos visuales modernos'
  }, {
    icon: <FileSearch size={32} data-id="element-173" />,
    text: 'Material teórico resumido'
  }, {
    icon: <Layers size={32} data-id="element-174" />,
    text: 'Contenido estructurado por año y tomo'
  }];
  return <section className="py-16 px-4 bg-sky-50 border-y border-sky-100" data-id="element-175">
      <div className="max-w-5xl mx-auto" data-id="element-176">
        <div className="text-center mb-12" data-id="element-177">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-4 uppercase" data-id="element-178">
            📘 ¿QUÉ INCLUYE EL <span className="text-sky-600" data-id="element-179">SISTEMA?</span>
          </h2>
          <p className="text-lg md:text-xl text-slate-600 font-medium max-w-2xl mx-auto" data-id="element-180">
            Accedé al sistema académico completo que organiza TODO tu trabajo
            docente en un solo lugar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-181">
          {features.map((feature, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border border-sky-100 flex flex-col items-center text-center hover:-translate-y-1 hover:shadow-lg transition-all duration-300" data-id="element-182">
              <div className="bg-sky-100 text-sky-600 p-4 rounded-full mb-4" data-id="element-183">
                {feature.icon}
              </div>
              <h3 className="font-bold text-lg text-slate-800" data-id="element-184">
                {feature.text}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}